require "./views/login_form_view"
{gdprCookieBanner} = require "../../cookie_banner_gdpr/frontend/main"

if $('body').hasClass 'authentication'
  $(document).ready ->
    loginFormView = new Extranet.Views.LoginFormView()
    gdprCookieBanner()
